module.exports = __webpack_public_path__ + "static/media/BoroughHallEXTA0001b_bg_clean_v001.bee6f2b7.webp";